import { CsvImportFilter } from './REPORT_CONFIG';

export const APPS_IMPORT_OPTIONS: Array<CsvImportFilter> = [
  {
    key: 'region',
    label: 'Region',
    type: 'checkbox',
    options: [
      {
        label: 'Global',
        value: 'GLOBAL'
      },
      {
        label: 'APAC',
        value: 'APAC'
      },
      {
        label: 'EMEA',
        value: 'EMEA'
      },
      {
        label: 'LATAM',
        value: 'LATAM'
      },
      {
        label: 'North America',
        value: 'NA'
      }
    ]
  },
  {
    key: 'device',
    label: 'Device',
    type: 'checkbox',
    options: [
      {
        label: 'Global',
        value: 'GLOBAL'
      },
      {
        label: 'Smartphone',
        value: 'smartphone'
      },
      {
        label: 'Tablet',
        value: 'tablet'
      }
    ]
  },
  {
    key: 'appStore',
    label: 'App Store',
    type: 'checkbox',
    options: [
      {
        label: 'Google Play',
        value: 'android'
      },
      {
        label: 'iOS',
        value: 'ios'
      }
    ]
  }
];
